export default "__VITE_ASSET__7fedd6e8__"